





























import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SearchSelectField",
  props: {
    placeholderText: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    focus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.focus) {
      const $input = this.$refs.input as HTMLElement;
      $input.focus();
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        this.$emit("input", event.target.value);
        this.$emit("change", event.target.value);
      }
    }
  }
});
